// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	InstantSearch.prototype.afterRender = function(){
		var input = jQ(document).find('[data-predictive-search-drawer-input]').first();
		input.on('focus keyup keydown cut copy paste', function(){
			var checkInterval = setInterval(function(){
				var right = jQ(window).width() - input.offset().left - input.outerWidth();
				jQ(document).find('.boost-pfs-search-suggestion-wrapper').css('right', right + 'px');
			}, 100)
			setTimeout(function(){
				clearInterval(checkInterval);
			}, 100)
		})
	}

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		/*
		if(jQ('.js-drawer-close').length > 0){
			setTimeout(function() {
				jQ('.js-drawer-close').trigger('click');
			});
		}
		*/
	};

	SearchInput.prototype.customizeInstantSearch= function() {
		console.log('customizeInstantSearch');

		// Hide debut's search suggestion
		/*
		if (jQ('.predictive-search-wrapper').length > 0){
				jQ('.predictive-search-wrapper').hide();
		}
		*/
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
    if(!jQ(searchBoxId).length === 0) return;
    
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if(jQ('body').hasClass(Class.searchSuggestionMobileOpen)){    
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
	
		// Close search theme debut
		/*
		if(jQ('.js-drawer-close').length > 1){
			jQ('.js-drawer-close').trigger('click');
		}
		*/
	}

  InstantSearchMobile.prototype.onClickOutsideSuggestionMobileEvent = () => {
		// override function. remove register touchstart. Please don't remove this function
  }
  
  InstantSearchMobile.prototype.showSearchBoxMobile = function() {
    this.isOpen = true;
    // Click outside suggestion and close the suggestion
    this.onClickOutsideSuggestionMobileEvent();
    // Close keyboard when scrolling on mobile
    this.scrollSuggestionMobileEvent();
    // Display or not the clear button
    if (Utils.stripHtml(this.$searchInput.val()) == '') {
      this.$clearButtonElement.hide();
    } else {
      this.$clearButtonElement.show();
    }
    
    // remove suggestionMobileOverlap, DON'T DELETE
    const suggestionMobileOverlap = jQ('#boost-pfs-search-suggestion-mobile');
    if(suggestionMobileOverlap.length > 0) {
			suggestionMobileOverlap.remove();
    }
    
    // update correct input
    const isMobileInputFocus = jQ('#boost-pfs-search-box-0').is(':focus');
    
    if (!isMobileInputFocus) {
      // Display the Search box on Top
      this.$topPanelElement.show();
      this.$overlayElement.show();
      // Remove Lock focus on Menu mobile, Dialog,... which have tabindex=-1
      jQ('[tabindex="-1"]').removeAttr('tabindex').addClass(Class.searchSuggestionNoTabIndex);
      if (Utils.isMobile() && jQ("[data-open=true]").length > 0) {
        jQ("[data-open=true]").attr('data-open', false);
      }
      // Focus Search box
      setTimeout(() => {
        this.$searchInput.focus();
      }, 100);
      // After showing the Search box on top on mobile
      this.afterShowSearchBoxMobile();
      
    }
  }

  Object.keys(window).forEach(key => {
      if (/^on/.test(key)) {
          window.addEventListener(key.slice(2), event => {
              if(!jQ('body').hasClass('boost-pfs-enable-instant-search')){
                boostPFS.initSearchBox();
              }
          });
      }
  });

})();